import classNames from "classnames";
import React from "react";
import { AppListItem } from "../AppList";
import AppSwitch from "../AppSwitch/AppSwitch";

interface BaseProps {
  label?: string;
  checkedLabel?: string;
  uncheckedLabel?: string;
  trailing?: React.ReactNode;
  disabled?: boolean;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

interface WithFixedTitle {
  label: string;
  checkedLabel?: undefined;
  uncheckedLabel?: undefined;
}

interface WithConditionalTitles {
  label?: undefined;
  checkedLabel: string;
  uncheckedLabel: string;
}

type Props = BaseProps & (WithFixedTitle | WithConditionalTitles);

const SwitchListItem = (props: Props) => {
  const title = React.useMemo(() => {
    if (props.label !== undefined) {
      return props.label;
    }

    return props.checked ? props.checkedLabel : props.uncheckedLabel;
  }, [props.label, props.checked, props.checkedLabel, props.uncheckedLabel]);

  const handleChange = React.useCallback(() => {
    if (props.disabled !== true) {
      props.onChange.call(null, !props.checked);
    }
  }, [props.disabled, props.onChange, props.checked]);

  return (
    <AppListItem
      className={classNames("SwitchListItem", { disabled: props.disabled === true })}
      leading={<AppSwitch checked={props.checked} disabled={props.disabled} />}
      title={title}
      trailing={props.trailing}
      onClick={handleChange}
    />
  );
};

export default SwitchListItem;
